import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader/loader";
import AddIntent from "./AddIntent";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { useGetAllIntentMutation, useGetIntentByIdMutation } from "./Api";
import { FaEdit } from "react-icons/fa";

const KBIntentTable = () => {

    const [getAllIntentApi, { isLoading }] = useGetAllIntentMutation()
    const [getIntentByIdApi, { isLoading: getIntentByIdIsloading }] = useGetIntentByIdMutation()

    const [intent, setIntent] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    const navigate = useNavigate()

    const requestIdRef = useRef(0);

    const searchInputRef = useRef(null);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);

    useEffect(() => {
        getAllIntent()
    }, [rowsPerPage, currentPage, status, debouncedSearch]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch]);


    const getAllIntent = async () => {
        try {
            const requestId = ++requestIdRef.current;

            const response = await getAllIntentApi({
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch
            })

            // keep cursor in search input
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 1);

            if (requestId !== requestIdRef.current) return;

            if (response?.data?.success) {
                setIntent(response?.data?.data?.intent)
                setTotalRecords(response?.data?.data?.pagination.total || 0);
                setTotalPages(response?.data?.data?.pagination.totalPages || 1);
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    // Drawer open close
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // Open drawer for creating new dropdown
    const handleCreateIntent = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleSave = () => {
        handleCloseDrawer(); // Close 
        setStatus(!status)  // for get new data after new intent upload
    };

    // Update Drawer
    const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
    const [intentData, setIntentData] = useState()

    const handleUpdateCloseDrawer = () => {
        setIsUpdateDrawerOpen(false);
    };

    const handleUpdateSave = () => {
        handleUpdateCloseDrawer(); // close toggle
        setStatus(!status)  // for get new data after new role upload
    };


    const getIntentById = async (id) => {
        try {
            const response = await getIntentByIdApi({ id: id })

            if (response.data.success) {
                setIsUpdateDrawerOpen(true)
                setIntentData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || getIntentByIdIsloading ? <Loader /> :
                <div className="card p-3 mb-4">
                    <div className="card shadow-sm border-0 p-3 mb-4">
                        <div className="row justify-content-end g-3">

                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <input
                                    ref={searchInputRef}
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search intent by name..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            <div className="col-12 col-sm-6 col-md-3 col-lg-auto">
                                <button className="btn btn-primary btn-compact" onClick={handleCreateIntent}>
                                    Create Intent
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Intent Name</th>
                                    <th>Description</th>
                                    <th>Keywords</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading && intent?.length > 0 ? (
                                    intent.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.intent_name}</td>
                                            <td>{item.description}</td>
                                            <td>
                                                {item.keywords && item.keywords.length > 0 ? (
                                                    item.keywords.map((kw, i) => (
                                                        <span
                                                            key={i}
                                                            // style={{
                                                            //     background: "#e9ecef",
                                                            //     padding: "4px 8px",
                                                            //     borderRadius: "12px",
                                                            //     marginRight: "5px",
                                                            //     display: "inline-block",
                                                            //     fontSize: "12px"
                                                            // }}
                                                            className="keyword-tag"
                                                        >
                                                            {kw}
                                                        </span>
                                                    ))
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td>
                                                <span
                                                    className={`badge ${item.status === "active"
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                        }`}
                                                >
                                                    {item.status
                                                        ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
                                                        : "-"}
                                                </span>
                                            </td>
                                            <td
                                                style={{ cursor: "pointer" }}
                                                onClick={() => getIntentById(item.id)}
                                            >
                                                <FaEdit size={18} />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {/* Pagination */}

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                            <div className="d-flex align-items-center gap-1 small">

                                <span>Show</span>

                                <select
                                    className="form-select form-select-sm page-size-select"
                                    value={rowsPerPage}
                                    onChange={(e) => {
                                        setRowsPerPage(Number(e.target.value));
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                </select>

                                <span>entries</span>

                            </div>

                            <div className="small text-muted">
                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                            </div>

                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                maxPagesToShow={rowsPerPage}
                                onPageChange={(page) => setCurrentPage(page)}
                            />

                        </div>
                    </div>
                    {isDrawerOpen && (
                        <AddIntent
                            mode="add"
                            onClose={handleCloseDrawer}
                            onSave={handleSave}
                        />

                    )}

                    {isUpdateDrawerOpen && (
                        <AddIntent
                            mode="update"
                            onClose={handleUpdateCloseDrawer}
                            onSave={handleUpdateSave}
                            data={intentData}
                        />
                    )}
                </div>
            }
        </div>
    );
};

export default KBIntentTable;